/* np-e2-pdp-handoff.js — STAGING armor (Justin 2026-08-24).
   The Size & Pricing hand-off for the on-page pricing experiment, kept in
   its OWN asset because parallel np-emb2.js pushes wiped these hunks twice
   on 2026-08-24. Runtime-gated on the experiment's own signals and it
   stands DOWN wherever np-emb2.js already provides the behavior:
   - relabels the Backing row's Continue to "Continue to Size & Pricing"
   - injects that button when the answered row has none (older np-emb2.js
     blanks it after the last answer)
   - collapse + scroll/focus to Size & Pricing on button click, and on a
     header-collapse of the answered row
   - lands the final review at its top (not the footer) when the page
     enters np-e2-final and the collapsed layout strands the scroll offset */
(function () {
  'use strict';
  function gateOn() {
    var card = document.getElementById('np-e2-step-pricing');
    return document.body.classList.contains('np-e2-pdp-pricing') && !!card && !card.hidden;
  }
  function scrollPad() {
    /* mirrors np-emb2.js npScrollPad: scrolled-to targets land below the
       mobile sticky preview */
    var stk = document.getElementById('np-e2-msticky');
    if (stk && window.innerWidth < 1367) {
      var r = stk.getBoundingClientRect();
      if (r.height > 40) return Math.round(r.bottom + 14);
    }
    return 120;
  }
  function focusPricing() {
    var card = document.getElementById('np-e2-step-pricing');
    if (!card || card.hidden) return;
    /* desktop clearance is the collapsed sticky nav (~64px), not the 120px
       general pad — the bigger pad left the collapsed Backing row peeking
       above Size & Pricing */
    var yOf = function () { return Math.max(0, card.getBoundingClientRect().top + window.pageYOffset - (window.innerWidth < 1367 ? scrollPad() : 76)); };
    setTimeout(function () {
      /* INSTANT jump, not smooth — shifting layout kept invalidating the
         smooth animation and the landing arrived seconds late */
      window.scrollTo({ top: yOf(), behavior: 'auto' });
      setTimeout(function () { try { card.setAttribute('tabindex', '-1'); card.focus({ preventScroll: true }); } catch (e) {} }, 120);
    }, 60);
    /* the smooth scroll gets short-stopped by post-click re-compose jank and
       late layout shifts, leaving the options half on screen — re-assert the
       landing until it sticks (Justin 2026-08-24) */
    [600, 1200, 1900].forEach(function (ms) {
      setTimeout(function () {
        var y = yOf();
        if (Math.abs(window.pageYOffset - y) > 140) window.scrollTo({ top: y, behavior: 'auto' });
      }, ms);
    });
  }
  function lastRow() { return document.querySelector('.np-e2-accrow[data-e2-acc="5"]:not([hidden])'); }
  function backingSet() {
    var v = document.querySelector('[data-e2-val="backing"]');
    return !!(v && v.classList.contains('is-set'));
  }
  var LABEL = 'Continue to Size & Pricing';
  function groom() {
    if (!gateOn()) return;
    var row = lastRow();
    if (!row) return;
    var body = row.querySelector('[data-e2-accbody="5"]');
    if (!body || body.hidden) return;
    var btn = body.querySelector('.np-e2-acc-cont__btn');
    if (btn) {
      /* a native button exists — its own np-emb2.js handler owns the click;
         we only make sure it names the on-page destination */
      if (btn.textContent !== LABEL) btn.textContent = LABEL;
      return;
    }
    if (!backingSet()) return;
    var cont = body.querySelector('.np-e2-acc-cont');
    if (!cont) { cont = document.createElement('div'); cont.className = 'np-e2-acc-cont'; body.appendChild(cont); }
    cont.innerHTML = '<button type="button" class="np-e2-btn np-e2-btn--green np-e2-acc-cont__btn" data-np-pdp-accdone="1">' + LABEL + '</button>';
  }
  var mo = new MutationObserver(function () {
    if (mo.__t) return;
    mo.__t = setTimeout(function () { mo.__t = null; groom(); }, 0);
  });
  (function arm() {
    var acc = document.getElementById('np-e2-acc');
    if (!acc) { setTimeout(arm, 500); return; }
    mo.observe(acc, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'class'] });
    groom();
  })();
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    /* a backing tile was just picked: the theme's own tile handler already
       ran (target phase) and re-rendered the row, so groom RIGHT NOW — the
       button lands in the same paint. Waiting for the observer's timer let
       the post-click canvas re-compose starve it (~1s pop-in). The clicked
       tile is detached by the re-render, but its old tree still answers
       closest() (Justin 2026-08-24). */
    if (t.closest('[data-e2-pick="backing"]')) { groom(); return; }
    /* OUR injected button only (a native data-e2-accdone button is handled
       by np-emb2.js itself): close the row through its own header toggle so
       the main file's accordion state stays the single source of truth */
    var mine = t.closest('[data-np-pdp-accdone]');
    if (mine && gateOn()) {
      var row = lastRow();
      var head = row && row.querySelector('[data-e2-acchead="5"]');
      var body = row && row.querySelector('[data-e2-accbody="5"]');
      if (head && body && !body.hidden) head.click();
      focusPricing();
      return;
    }
    /* collapsing the answered Backing row by its header = the same hand-off */
    var hd = t.closest('[data-e2-acchead="5"]');
    if (hd && gateOn() && backingSet()) {
      setTimeout(function () {
        var body = document.querySelector('[data-e2-accbody="5"]');
        if (body && body.hidden) focusPricing();
      }, 100);
    }
  });
  /* final review lands at its TOP: the final layout removes the tall option
     and pricing cards, and the browser clamps the stale offset to the footer */
  var wasFinal = document.body.classList.contains('np-e2-final');
  new MutationObserver(function () {
    var isF = document.body.classList.contains('np-e2-final');
    if (isF && !wasFinal) {
      var toTop = function (assertOnly) {
        var hd = document.getElementById('np-e2-final-head') || document.getElementById('np-e2-approved');
        if (!hd) return;
        var y = Math.max(0, hd.getBoundingClientRect().top + window.pageYOffset - scrollPad());
        if (!assertOnly || window.pageYOffset > y + 300) window.scrollTo({ top: y, behavior: 'auto' });
      };
      setTimeout(function () { toTop(false); }, 200);
      /* keep re-asserting while late images/layout settle (6s) — only when
         still stranded well BELOW the review, never against a user scroll */
      var n = 0;
      var iv = setInterval(function () {
        /* 20s window: reviews-section images below the builder keep loading
           long after the final page lands and re-strand the clamped scroll
           (Justin 2026-08-24) */
        if (++n > 40) { clearInterval(iv); return; }
        toTop(true);
      }, 500);
    }
    wasFinal = isF;
  }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
})();
